import { render, staticRenderFns } from "./newscarousel.vue?vue&type=template&id=39dce27c&scoped=true"
import script from "./newscarousel.vue?vue&type=script&lang=js"
export * from "./newscarousel.vue?vue&type=script&lang=js"
import style0 from "./newscarousel.vue?vue&type=style&index=0&id=39dce27c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dce27c",
  null
  
)

export default component.exports